import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Report from '../../../common/components/Report';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/EpgLinkByLinkSelectors';

class EpgLinkByLinkContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showColorLegend: true,
      // eslint-disable-next-line react/no-unused-state
      showModal: true,
    };
  }

  closeChart = () => {
    this.setState({
      // eslint-disable-next-line react/no-unused-state
      showModal: false,
    });
  };

  render() {
    return (
      <Report
        reportId={ReportDefinitions.EPG_LINK_BY_LINK_REPORT_013.id}
        generatedOnDateTime={this.props.generatedDateTime}
        isLoading={this.props.isLoading}
        data={this.props.data}
        columns={this.props.columns}
        className="impcToImpcDespatchPerformanceReport"
        showColorLegend={this.state.showColorLegend}
        closeChart={this.closeChart}
      />
    );
  }
}

function mapStateToProps(state, props) {
  return {
    data: getData(state, props),
    columns: getColumns(state, props),
    generatedDateTime: getGeneratedOnDateTime(state, props),
    isLoading: getIsLoading(state, props),
  };
}

EpgLinkByLinkContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps)(EpgLinkByLinkContainer);
